import BaseComponentController from "../base_component_controller"

export default class extends BaseComponentController {
  static targets = ['input', 'fileName', 'removeInput', 'remover', 'preview', 'progressBar']

  static values = {
    filenameOptions: { type: Object, default: {} },
    mode: { type: String, default: 'single' }
  }

  connect() {
    this.file = null
    this.multipleFileInputGroupIdentifier = 'design-system--form--multiple-file-input-group-component'

    this.element.addEventListener(`${this.multipleFileInputGroupIdentifier}:file-added`, (e) => {
      this.file = e.detail.file
      this.showFile()
    })

    this.dispatchEvent({ action: 'connected' })
  }

  triggerInput(event) {
    event?.preventDefault()

    if (!this.removerTarget.contains(event.target)) {
      this.inputTarget.click()
    }
  }

  handleInputChange(event) {
    this.dispatchEvent({ action: 'before-change' })
    this.file = event.target.files[0]
    this.showFile()
    this.dispatchEvent({ action: 'after-change' })
  }

  handleRemoveFile(event) {
    event?.preventDefault()
    this.dispatchEvent({ action: 'before-remove-file', options: { detail: { file: this.file } } })
    this.hideFile()
    this.dispatchEvent({ action: 'after-remove-file', options: { detail: { file: this.file } } })
    this.file = null
  }

  showFile() {
    this.fileNameTarget.innerHTML = this.file.name
    this.fileNameTarget.classList.remove(this.filenameOptionsValue.out.class)
    this.fileNameTarget.classList.add(this.filenameOptionsValue.in.class)

    this.removerTarget.classList.remove(this.hiddenClass)

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add(this.hiddenClass)
    }

    if (this.hasRemoveInputTarget) {
      this.removeInputTarget.value = '0'
    }
  }

  hideFile() {
    if (this.elementIsRemovable) {
      this.element.remove()
      return
    }

    if (this.hasRemoveInputTarget) {
      this.removeInputTarget.value = '1'
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.remove()
    }

    this.fileNameTarget.innerHTML = this.filenameOptionsValue.out.text
    this.fileNameTarget.classList.remove(this.filenameOptionsValue.in.class)
    this.fileNameTarget.classList.add(this.filenameOptionsValue.out.class)

    if (this.hasInputTarget) {
      this.inputTarget.value = null
    }

    this.removerTarget.classList.add(this.hiddenClass)
  }

  updateProgressBar(progressPercentage) {
    this.progressBarTarget.style.width = `${progressPercentage}%`
  }

  get multipleMode() {
    return this.modeValue === 'multiple'
  }

  get elementIsRemovable(){
    return this.multipleMode
  }

  get hiddenClass() {
    return 'hidden'
  }
}
